export interface NamedIdentified {
  readonly id: string;
  readonly name: string;
}

export function isNamedIdentified(value: any): value is NamedIdentified {
  return (
    typeof value === 'object' &&
    value !== null &&
    (typeof value.id === 'string' || typeof value.id === 'number') &&
    typeof value.name === 'string'
  );
}
